<form #f="ngForm" [formGroup]="informationAddForm">
  <div style="margin-top: 20px;" class="container-fluid">
    <div class="form-row">
      <div class="col-md-6">
        <div [ngClass]="{'has-error': title.invalid && (title.dirty || title.touched)}" class="form-group mb-4">
          <label for="title">{{ "titleEnvelope" | translate | titlecase}}<i class="gray-30 ml-1">{{"(mandatory)" |
              translate | titlecase}}</i></label>
          <div class="inputWithIcon-left">
            <input type="text" class="form-control" id="title" formControlName="title"
              (keydown.enter)="$event.preventDefault()" (blur)="setReplaceTitle()" />
            <fa-icon [icon]="['fas','envelope-open-text']"></fa-icon>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6 mt-0 mb-3 mb-md-0"
            [ngClass]="{'has-error': informationAddForm.get('expiration').hasError('dateInvalid')}">
            <label>{{ "expiration" | translate | titlecase }}</label>
            <div class="mt-n2">
              <cdx-date-picker-container [options]="datePickerContainerOptions" [model]="datePickerContainerModel"
                (onSelectedDate)="onExpirationSelectItem($event)" (keydown.enter)="$event.preventDefault()">
              </cdx-date-picker-container>
            </div>
          </div>
          <div class="form-group col-md-6 mt-0 mb-4">
            <label>
              {{ "language" | translate | titlecase }}
              <fa-icon ngbTooltip="{{ 'envelope.settings.tooltip.languageSettings' | translate }}" class="ml-1 fa-gray"
                size="sm" [icon]="['fas', 'question-circle']">></fa-icon>
            </label>
            <cdx-dropdown [options]="languageEnvelopedropdown" [selectedItem]="languageSelected"
              (onSelectItem)="onLanguageSelectItem($event)"></cdx-dropdown>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6 mt-0 mb-4">
            <label>{{ "envelope.settings.segmentText" | translate | titlecase }}<i *ngIf="isRequiredUserSegment"
                class="gray-30 ml-1">({{ 'required' | translate }})</i></label>
            <cdx-dropdown [options]="segmentdropdown" [selectedItem]="segmentSelected"
              (onSelectItem)="onSegmentSelectItem($event)" (click)="showModalSegment(confirmModal)">
            </cdx-dropdown>
          </div>
          <div class="form-group col-md-6 mt-0 mb-4">
            <label>{{'envelope.settings.sendReminder' | translate}}</label>
            <cdx-dropdown [options]="rememberOptions" [selectedItem]="reminderFrequencySelected"
              (onSelectItem)="onSelectFrequency($event)"></cdx-dropdown>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="message">{{ "message" | translate | titlecase }}</label>
          <textarea style="height: 217px;" class="form-control form__message" rows="10" id="message"
            formControlName="message" placeholder="{{ 'messageExample' | translate }}"></textarea>
        </div>
      </div>
      <div class="form-row mt-0 ml-0 col-md-6">
        <div class="before-label">
          <cdx-toggle-switch class="toggleRejec" [toggledOn]="rejectToggleSelected" (toggle)="onRejectToggle($event, true)"
            [disabled]="envelope?.status === sentEnvelopeStatus.rejected"></cdx-toggle-switch>
        </div>
        <label class="toggleRejectLabel">&nbsp; {{ "envelope.settings.toggle.reject" | translate }}</label>
      </div>
    </div>
    <div class="form-row mt-2">
      <div class="col-md-6">

        <div class="header mb-2">
          {{ "envelope.settings.atachedFiles" | translate | titlecase }}
        </div>
        <div class="body ">
          <div *ngFor="let file of files; let i = index">
            <div class="file">
              <span class="text-truncate"> {{ file.name }}</span>
              <div>
                <fa-icon [icon]="['far','trash-alt']" (click)="removeFile(i)"></fa-icon>
              </div>
            </div>
            <cdx-helper *ngIf="validFileRejected(file);" [options]="{text: 'envelope-edit.documentRefused', hasError: true}"></cdx-helper>
          </div>
        </div>

      </div>
    </div>

    <div class="form-row mt-2">
      <button (click)="restoreFiles()" class="cdx-button cdx-button--secondary cdx-button--outline">
        <span class="cdx-button__text">{{ 'envelope-edit.restoreFile' | translate | titlecase }}</span>
      </button>
    </div>
  </div>
</form>

<ng-template #confirmModal>
  <app-alert-modal-ok [MessageText]="'envelope.main-envelope.message-segment-modal.messageText'"
    [HeaderText]="'envelope.main-envelope.alert-modal.headerText'" (closeModalClick)="confirmModalClose()"
    (confirmModalClick)="confirmModalYesClick()">
  </app-alert-modal-ok>
</ng-template>

<ng-template #confirmRemoveFileModal>
  <app-confirm-modal [HeaderText]="'envelope-edit.deleteFileModal.headerText'"
    [QuestionText]="'envelope-edit.deleteFileModal.questionText'"
    [MessageText]="'envelope-edit.deleteFileModal.messageText'"
    (closeModalClick)="confirmModalClose()" (confirmModalClick)="confirmRemoveFileClick()"
    [ButtonConfirmText]="'envelope-edit.deleteFileModal.complete'" [ButtonCancelText]="'envelope-edit.deleteFileModal.back'" [IsApprovalConfirm]=false>
  </app-confirm-modal>
</ng-template>
